import React from "react";
import contact from "../../assets/svg/kontakt.svg";
import { RequestForm } from "./RequestForm";
import { useTranslation } from "../../plugins/i18next/ea-react-i18next";

export const SupportRequest = () => {
  const { t } = useTranslation("components", { keyPrefix: 'zammad.supportRequest' });
  return (
    <section className="contact-area ptb-70">
      <div className="container-fluid hero-container">
        <div className="row">
          <div className="col-lg-6 col-md-12">
            <div className="about-content our-mission-content">
              <div className="content">
                <h2>{t("title")}</h2>
                <p>{t("description")}</p>
                <div className="contact-image">
                  <img src={contact} alt="contact" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-12">
            <h3 className="contact-form-message">{t("leaveMessage")}</h3>
            <div className="contact-form">
              <div className="row">
                <div className="col-lg-12 col-md-6">
                  <RequestForm />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
